import React, { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Card, MainSection } from "../components/common_components/Layout";
import MissionsSection from "../components/dashboard_components/MissionsSection";
import UpcomingSessionsSection from "../components/dashboard_components/UpcomingSessionsSection";
import WelcomeRow from "../components/dashboard_components/WelcomeRow";
import { MissionTutorialCard } from "../components/dashboard_components/TutorialContent";


// Api Calls
import MissionsAPI from "../api/api_calls/MissionAPI";
import ScheduledEventAPI from "../api/api_calls/ScheduledEventAPI";

function Dashboard(props) {

    const [loadMissionsComplete, setLoadMissionsComplete] = useState(false);
    const [missions, setMissions] = useState([]);
    const [loadSessionsComplete, setLoadSessionsComplete] = useState(false);
    const [upcomingSessions, setUpcomingSessions] = useState([]);
    const navigate = useNavigate();

    const [updateMissionCount, setUpdateMissionCount] = useState(0);


    useEffect(() => {
        // Grab information on this user

        async function getMissions() {
            const result = await MissionsAPI.index(navigate);

            if (result.success) {
                setMissions(result.missions);
                setLoadMissionsComplete(true);

            } else {
                setLoadMissionsComplete(false);
            }

        }

        async function getUpcomingSessions() {
            const result = await ScheduledEventAPI.all_missions_upcoming_events(navigate);

            if (result.success) {
                setUpcomingSessions(result.scheduled_events);
                setLoadSessionsComplete(true);

            } else {
                setLoadSessionsComplete(false);
            }
            console.log(result.scheduled_events);

        }

        getMissions();
        getUpcomingSessions();
    }, [updateMissionCount]);

    function UpdateMissions() {
        setUpdateMissionCount(updateMissionCount + 1);
    }

    return (
        <>
            <MainSection>
                <div className="dashboard-top-section">
                    <WelcomeRow />
                    <UpcomingSessionsSection sessions={upcomingSessions} loadSessionsComplete={loadSessionsComplete} />
                </div>
                <MissionsSection missions={missions} loadMissionsComplete={loadMissionsComplete} updateMissions={UpdateMissions} />
                <MissionTutorialCard />
            </MainSection>
        </>

    )

}



export default Dashboard;